import { FlagMunicipality } from 'shell/models/municipality';

export const transformMunicipalityFlag = (type: FlagMunicipality): string => {
  switch (type) {
    case FlagMunicipality.Active:
      return 'Comune attivo';
    case FlagMunicipality.Edited:
      return 'Comune variato';
    case FlagMunicipality.Ended:
      return 'Comune cessato';
    case FlagMunicipality.NewDescription:
      return 'Nuova descrizione';
    case FlagMunicipality.NotSuitable:
      return 'Non attendibile';
    case FlagMunicipality.Void:
      return 'Comune variato';
    default:
      return '';
  }
};
